import { ChevronRight } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from '@mui/x-data-grid';

import {
  capitalize,
  formatDateBR,
  formatDateWithDaysAdded,
  formatMoney,
  formatPeriodDate,
} from '@octopus/formatters';
import { ExpandableTypography } from '@octopus/ui/shared-components';

import { BASE_COLUMN_WIDTH } from './Constants';

export const periodColumn = (): GridColDef => {
  return {
    field: 'period',
    headerName: 'Competência',
    sortable: true,
    valueGetter: (params) => {
      return formatPeriodDate(params.row.period);
    },
  };
};

export const workerNameAndSalaryColumn = (): GridColDef => ({
  field: 'name',
  headerName: 'Colaboradores',
  flex: 1,
  valueGetter: (params: GridValueGetterParams) => {
    return params.row.workerData.name;
  },
  renderCell: (params: GridRenderCellParams) => {
    const name = params.row.workerData.name;
    const salary = params.row.workerData.salary;

    return (
      <Box>
        <ExpandableTypography>{capitalize(name)}</ExpandableTypography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ lineHeight: 2.5 }}
        >
          {formatMoney(salary)}/mês
        </Typography>
      </Box>
    );
  },
});

export const approvalDateColumn = (): GridColDef => {
  return {
    field: 'approvalDate',
    headerName: 'Aprovar até',
    flex: 0,
    width: BASE_COLUMN_WIDTH,
    maxWidth: BASE_COLUMN_WIDTH,
    valueGetter: (params: GridValueGetterParams) => {
      return formatDateBR(
        formatDateWithDaysAdded(params.row.paymentDate || params.row.date, -2),
      );
    },
  };
};

export const reviewActionColumn = (): GridColDef => {
  return {
    field: 'reviewCall',
    headerName: '',
    flex: 0,
    width: BASE_COLUMN_WIDTH,
    maxWidth: BASE_COLUMN_WIDTH,
    renderCell: () => {
      return (
        <Box display="flex" justifyContent="center" alignContent="center">
          <Typography variant="body2" color="info.main" fontWeight={550}>
            Revisar
          </Typography>
          <ChevronRight
            sx={{
              color: 'blue',
              height: '18px',
              width: '18px',
              pt: 0.15,
            }}
          />
        </Box>
      );
    },
  };
};
